// frontend/src/components/Login.js
import React, { useState } from 'react';
import '../styles/Login.css';
import { API_BASE_URL } from '../services/api';

const Login = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // Invia la password al backend per autenticazione
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Errore durante autenticazione');
      }

      // Ottieni il token JWT dalla risposta
      const data = await response.json();
      
      // Salva il token in localStorage
      localStorage.setItem('authToken', data.access_token);
      
      // Imposta l'autenticazione a true
      onLogin(true);
    } catch (error) {
      console.error('Errore di autenticazione:', error);
      setError(error.message || 'Password non valida. Riprova.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img src="/images/logo.png" alt="Albert Logo" />
        </div>
        <h1 className="login-title">Albert</h1>
        <p className="login-subtitle">Intelligent Tutoring System</p>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserisci la password"
              required
            />
          </div>
          
          {error && <div className="login-error">{error}</div>}
          
          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Accesso in corso...' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;